import { render } from "./CreateTransferFrom.vue?vue&type=template&id=6ae753c8&scoped=true&ts=true"
import script from "./CreateTransferFrom.vue?vue&type=script&lang=ts"
export * from "./CreateTransferFrom.vue?vue&type=script&lang=ts"

import "./CreateTransferFrom.vue?vue&type=style&index=0&id=6ae753c8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ae753c8"]])

export default __exports__